import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project-imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// Lazy-loaded views
const SmsList = Loadable(lazy(() => import('views/sms/SmsList')));
const OzekiInbox = Loadable(lazy(() => import('views/ozeki/OzekiInbox')));
const ChangePassword = Loadable(lazy(() => import('views/settings/ChangePassword')));
const UserList = Loadable(lazy(() => import('views/users/UserList')));

// Render - dashboard pages
const DefaultPages = Loadable(lazy(() => import('views/navigation/dashboard/Default')));

// ==============================|| NAVIGATION ROUTING ||============================== //

const NavigationRoutes = {
  path: '/',
  element: <DashboardLayout />, 
  children: [
    {
      index: true,
      element: <DefaultPages />
    },
    {
      path: 'dashboard',
      element: <Navigate to="/ozeki-inbox" replace />
    },
    {
      path: 'dashboard/default',
      element: <Navigate to="/ozeki-inbox" replace />
    },
    {
      path: 'sms',
      element: <SmsList />
    },
    {
      path: 'ozeki-inbox',
      element: <OzekiInbox />
    },
    {
      path: 'users',
      element: <UserList />
    },
    {
      path: 'change-password',
      element: <ChangePassword />
    }
  ]
};

export default NavigationRoutes;
